import { Controller } from '@hotwired/stimulus';

export class CharacterCounterController extends Controller {
  static targets = [ 'count', 'input' ];
  static values = {
    countdown: {
      default: false,
      type: Boolean,
    },
  };

  connect() {
    this.update();
  }

  count() {
    let value = this.inputTarget.value.length;

    if (this.countdownValue) {
      const maxLength = this.inputTarget.maxLength;

      if (maxLength < 0) {
        console.error(
          `character-counter #count The input needs a maxlength attribute to use countdown. The current value is: ${maxLength}.`,
        );
      }

      value = Math.max(maxLength - value, 0);
    }

    return value;
  }

  update() {
    this.countTarget.innerHTML = this.count().toString();
  }
}
